//
import { getFetchDataFunction } from '../DataTableService'

/**
 * 
 */
const fetchDataTable = () => {

    //
    const url       = process.env.VUE_APP_API_ROUTE.concat( '/wh_product?filter[type]=promo' )
        , includes  = []
        , appends   = [ 'branch_offices', 'sale_prices', 'composition' ]

    return getFetchDataFunction( url, includes, appends )
}

//
export default fetchDataTable()
